import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { BulkRegisterOrderBusinessRequest } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { TranslateExcelOrderBusiness, RegisterOrderBusinessResultCounts } from '@/coreDomainsModule/translateExcelOrder';
import { BulkRegisterOrderBusinessAdapter } from './adapters/bulkRegisterOrderBusinessAdapter';

/**
 * 発注取引保存
 */
export class BulkRegisterOrderBusinessUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注取引を登録/更新する
   * @param orderBusinessInfo - 登録/更新する情報
   */
  public async execute(
    orderBusinessInfo: Record<string, TranslateExcelOrderBusiness>
  ): Promise<INetworkResult<RegisterOrderBusinessResultCounts, IError>> {
    try {
      const adapterData = BulkRegisterOrderBusinessAdapter.adapt(orderBusinessInfo);
      const requestInfo: BulkRegisterOrderBusinessRequest = {
        bulkRegisterOrderBusinessInfo: adapterData,
      };
      const response = await this.repository.bulkRegisterOrderBusiness(requestInfo);
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          return {
            status: {
              type: 'error',
              error: response.status.error,
            },
          };
        default:
          throw new Error();
      }

      const data = response.status.data;

      const responseData: RegisterOrderBusinessResultCounts = {
        registered: data.registeredOrderCount,
        alerted: data.alertedOrderCount,
      };

      return {
        status: {
          type: 'success',
          data: responseData,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: -1,
            code: 'unknown',
            message: '想定外のエラー',
          },
        },
      };
    }
  }
}
